/**
 * @function MobileNoEntriesTableRow
 * @param {STRING} className - Allows us to set a custom className. 
 * @param {STRING} text - Allows us to set a text. 
 * @returns {React.Component}
 * @example
 *  <MobileNoEntriesTableRow text="No entries." />
 */
export function MobileNoEntriesTableRow(props) {
    const className = props.className ?? "";
    const text = props.text ?? "There are no entries.";
  
    return (
      <div className={`mobile-no-entries-table-row flex-container align-center ${className}`}>
        <div className="flex-width">
          <p className="text-center no-entries-text">{text}</p>
        </div>
      </div>
    );
  }
  